import Link from 'next/link';
import React from 'react';
import { get_dynamic_styles } from '../../constant/DynamicStyles';
import { get_dynamic_styles_with_default_value } from '../../constant/DynamicStylesWithDefaultValue';
import {
  CardBoxDefaultStyles,
  CardMainDefaultStyles,
} from '../../constant/default_styles/ProductDetailsStyles';
import { get_data_by_current_language } from '../../utils/GetDataByLanguage';
import { useRouter } from 'next/router';
import { workAfterLoginRule } from '../../utils/workAfterLoginRule';
import LinkWithButton from '../../HOC/LinkWithButton';

const CustomCTAWithAttribute = ({ data, styles, listing_details, rules }) => {
  const router = useRouter();
  let url =
    listing_details?.attributes?.filter((it) =>
      data?.attribute_id
        ? it.id == data?.attribute_id
        : it.name == data?.attribute_name
    )[0]?.values[0] ?? '#';
  return (
    <div
      style={get_dynamic_styles_with_default_value(
        styles?.box_styles,
        CardMainDefaultStyles
      )}
    >
      <div
        className=" "
        style={get_dynamic_styles_with_default_value(
          styles?.box_styles,
          CardBoxDefaultStyles
        )}
      >
        <LinkWithButton
          href={url ?? '#'}
          disabled={!workAfterLoginRule(rules) || url == '#'}
          className={`w-full`}
          onClickAtDisabled={() => {
            if (!workAfterLoginRule(rules)) {
              router.push(`/sign-in?to=${router.asPath}`);
            }
          }}
        >
          <a
            className={`     rounded-button  flex items-center justify-center  gap-2 ${
              url == '#' ? 'opacity-50 cursor-not-allowed' : ''
            }`}
            type="button"
            target={data?.button_target ?? '_blank'}
            style={get_dynamic_styles(styles?.button_styles)}
            onClick={() => {
              if (!workAfterLoginRule(rules)) {
                router.push(`/sign-in?to=${router.asPath}`);
              }
            }}
          >
            {data?.icon && (
              <img
                className="w-auto object-cover  "
                style={get_dynamic_styles(styles?.icon_styles)}
                src={data?.icon}
                alt="image"
              />
            )}
            {data?.button_title && (
              <p
                className="text-lg font-semibold text-gray-700"
                style={get_dynamic_styles(styles?.text_styles)}
              >
                {get_data_by_current_language({
                  data_list: data?.translated_data,
                  key_name: 'button_title',
                  default_data: data?.button_title,
                })}
              </p>
            )}
          </a>
        </LinkWithButton>
      </div>
    </div>
  );
};

export default CustomCTAWithAttribute;
